const e={Base:"1.5rem",Lg:"2rem",Sm:"1.25rem",Xl:"2.25rem",Xxl:"3.75rem","2xl":"3.75rem"};export{e as LineHeight};
